module.exports = __webpack_public_path__ + "img/excelencia.1c37ce02.svg";